import React, { Component } from 'react';

export default class Loading extends Component {
  render () {
    const { className, ...others } = this.props;
    return (
      <div className={`pace-loading ${className}`} {...others}></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/views/Loading.js